import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'standard-based'
const initialState = {
  list: null,
}

export const search = createApiAction('teacher/standard-based/search', client.search('/api/teacher/standard-base-grading'))
export const save = createApiAction('teacher/standard-based/save',client.save('/api/teacher/standard-base-grading'),)

// export const get = createApiAction('academic/course-session/get', client.search('/api/academic/course-session/:id'))
const update = (state, action) => {
  const updatedItem = action.payload;
  const updatedList = state.list.map(item => {
    if (item.id === updatedItem.id) {
      return { ...item, ...updatedItem }
    }
    return item
  })
  state.list = updatedList
}

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {

  },
  extraReducers(builder) {
    builder.addCase(search.fulfilled, (state, action) => {
      state.list = action.payload
      
    })
    builder.addCase(save.fulfilled, update)
  },
})

export const { setSelectedCourseSession } = sessionSlice.actions
export default sessionSlice.reducer
